import type { ContentDisposition } from "@tinyhttp/content-disposition";
import { parse } from "@tinyhttp/content-disposition";
import { getProPageHeaders } from "@similarweb/pro-logic-components";
declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean;
    }
}

export type ExcelDownloadResult = { success: boolean; error?: any };

export type ExcelDownloadClient = (url: string, body?: any, options?: RequestInit) => Promise<ExcelDownloadResult>;

export default async (url: string, body?: any, options?: RequestInit): Promise<ExcelDownloadResult> => {
    try {
        const response = body
            ? await fetch(url, {
                  ...options,
                  method: "POST",
                  body: JSON.stringify(body),
                  headers: { "content-type": "application/json", ...getProPageHeaders() },
              })
            : await fetch(url, { headers: getProPageHeaders() });
        const paidExcelHeader = response.headers.get("sw-excel-credit");
        if (paidExcelHeader) {
            throw new Error(paidExcelHeader);
        }
        const disposition: ContentDisposition = parse(response.headers.get("Content-Disposition"));
        const filename = disposition.parameters.filename as string;
        const csvFile = await response.blob();
        const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement("a");
            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        return { success: true };
    } catch (e) {
        return {
            success: false,
            error: e,
        };
    }
};
